'use client'
import { useState } from "react";
import styles from "./about-us.module.css";

const tabs = ["Experience", "Fleet", "Commitment"];

const tabContent = {
    Experience:
        "Pro Auto Rent (parent.ge) started in 2013 and quickly became a top car rental service in Georgia. We serve customers in Tbilisi, Kutaisi, Batumi, and their airports.",
    Fleet:
        "Our fleet consists of a wide range of vehicles—from economy and compact to SUV and luxury—all regularly serviced and maintained to ensure your comfort and safety.",
    Commitment:
        "We’re committed to providing exceptional customer service, flexible rental options, and transparent pricing to make your car-rental experience seamless and enjoyable.",
};

export default function AboutUs() {
    const [activeTab, setActiveTab] = useState("Experience");

    return (
        <div className={styles.aboutUsWrapper}>
            <section id="about-us" className={styles.aboutUs}>
                <div className={styles.aboutUsInfo}>
                    <h2>About us</h2>
                    <div>{tabContent.Experience}</div>
                </div>

                <div className={styles.aboutUsSwitchingModuleWrapper}>
                    <div className={styles.aboutUsSwitchingModule}>
                        <div className={styles.tabList}>
                            {tabs.map((tab) => (
                                <div
                                    key={tab}
                                    className={`${styles.tab} ${activeTab === tab ? styles.active : ""
                                        }`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </div>
                            ))}
                        </div>

                        <div className={styles.tabPanel}>
                            {tabContent[activeTab]}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
